import React from 'react'
import Header from '../Menpages/Header/Main'

import Bredcom from '../Menpages/Bredcom/Main'
import Whatweoffer from '../Meninsurance/Whatweoffer'
import Offer from '../Meninsurance/Offer'
import Slider from '../Menpages/GlobleSlider/Main'
import Footer from '../Menhome/Footer'

function Main() {
  return (
    <>
        <div className="page-wrapper">
            <Header/>
            <Bredcom title={"Home"} head={"Our Services"} sbtitle={"Services"}/>
            <Whatweoffer/>
            <Offer/>
            {/* <Slider/> */}
            <Footer/>
        </div>
    </>
  )
}

export default Main